<template>
  <div class="edit-base-shelf-item">
    <div class="edit-shelfname-label">logo及url<i class="vip">VIP</i></div>
    <el-select class="personal-item-select" size="mini" v-model="logo" @change="changeType">
      <el-option v-for="item in logoOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
    <div class="logoArea">
      <img src="@imgs/bookshelfdetail/logo@2x.png" alt="" v-if="logo == 0" />
      <div class="uploadlogo" v-if="logo == 1">
        <label class="uploadlogoButton" for="uploadlogoButton" @click="uploadLogoButtonHandler($event)">+上传logo</label>
        <input type="file" id="uploadlogoButton" ref="uploadALLogo" value="imgFile" accept="image/png, image/jpeg, image/jpg" @change="uploadImg($event)" style="display: none" />
        <div v-if="uploadLogo" class="thumbnail">
          <img :src="logoThumbnail" alt="" />
        </div>
        <div v-if="!uploadLogo" class="thumbnail">
          <p>建议尺寸102*42</p>
          <p>显示效果最佳</p>
        </div>
      </div>
      <div class="logo-jump">
        <span>链接跳转 </span>
        <el-select class="personal-item-select" size="mini" v-model="linkJump">
          <el-option label="开启" :value="1" />
          <el-option label="不开启" :value="0" />
        </el-select>
      </div>
      <div class="logoUrlTxt">点击logo跳转地址：</div>
      <el-input v-model="logoUrl" :disabled="logoDisabled"></el-input>
    </div>
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions"></tip-dialog>
    <LogoShear ref="Logocrop" :cropImgUrl.sync="cropImgUrl" :type="type"></LogoShear>
  </div>
</template>
<script>
import TipDialog from '@components/common/TipDialog.vue'
import LogoShear from './LogoShear'
import compareVipRight from '@components/common/compareVipRight.js'
export default {
  name: 'shelfLibLogo',
  data() {
    return {
      logo: 0, //默认值
      logoOptions: [
        {
          value: 0,
          label: '方正飞翔'
        },
        {
          value: 1,
          label: '自定义'
        }
      ],
      logoUrl: null,
      uploadLogo: false,
      cropImgUrl: '',
      linkJump: 1,
      baseUrl: window.PROJECT_CONFIG.BASE_URL
    }
  },
  mixins: [compareVipRight],
  computed: {
    logoThumbnail: {
      get: function() {
        let data1 = this.$store.state.config.bookLibLogo.logo
        let data2 = this.$store.state.config.bookShelfLogo.logo
        if (this.type.getType == 'Lib') {
          return data1
        } else {
          return data2
        }
      },
      set: function(newValue) {
        this.$store.commit('config/UPDATE_BOOK' + this.type.setType + 'LOGO', newValue)
      }
    },
    logoDisabled() {
      return (!(this.compare({ type: 'boole', key: 'replaceBookLogo' }) && this.compare({ type: 'boole', key: 'replaceLogoLink' })) && !!this.logo) || this.linkJump === 0
    },
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    }
  },
  methods: {
    async changeType(value) {
      if (value == 1) {
        if (!(await this.compareRight({ type: 'boole', key: 'replaceBookLogo' })) || !(await this.compareRight({ type: 'boole', key: 'replaceLogoLink' }))) {
          this.$refs.memberDialog.visible = true
          this.logo = 0
        }
      }
    },
    uploadLogoButtonHandler(e) {
      if (!this.compare({ type: 'boole', key: 'replaceBookLogo' })) {
        this.$refs.memberDialog.visible = true
        e.preventDefault()
      }
    },
    async uploadImg(e) {
      var _this = this
      //上传图片
      var file = e.target.files[0]
      _this.fileName = file.name
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        return false
      }
      let imgFile = new FileReader()
      imgFile.readAsDataURL(file)
      imgFile.onload = (res) => {
        _this.cropImgUrl = res.target.result
        _this.$refs.uploadALLogo.value = ''
        _this.$refs.Logocrop.dialogVisible = true
        _this.$nextTick(() => {
          _this.uploadLogo = true
          _this.$refs.Logocrop.init()
        })
      }
    }
  },
  components: {
    TipDialog,
    LogoShear
  },
  props: {
    type: Object
  }
}
</script>
<style lang="scss" scoped>
.logoArea {
  /deep/.el-input {
    width: 253px;
    .el-input__inner {
      border-color: #cecece;
      height: 27px;
      font-size: 14px;
      padding: 0 5px;
      line-height: 27px;
    }
  }
  img {
    width: 107px;
    margin: 5px 0;
  }
  .uploadlogo {
    margin-bottom: 10px;
    .uploadlogoButton {
      width: 100px;
      height: 24px;
      background: #df5813;
      color: #fff;
      border-radius: 15px;
      font-size: 14px;
      display: flex;
      display: inline-flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      margin: 10px 0;
      cursor: pointer;
    }
    .thumbnail {
      width: 102px;
      height: 42px;
      background: rgba(0, 0, 0, 0.6);
      color: #fff;
      p {
        width: 100%;
        text-align: center;
        font-size: 14px;
        margin: 0;
        line-height: 20px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .logo-jump {
    font-size: 15px;
    margin: 10px 0;
    .personal-item-select {
      width: 100px;
      /deep/.el-input--mini {
        width: 100%;
      }
    }
  }
  .logoUrlTxt {
    font-size: 15px;
    margin-bottom: 6px;
  }
}
.edit-shelfname-label {
  display: -webkit-flex;
  display: flex;
  align-items: center;
  img {
    height: 24px;
    margin-left: 2px;
  }
  i {
    width: 30px;
    line-height: 20px;
    background: #df5813;
    text-align: center;
    color: #fff;
    font-size: 10px;
    margin-left: 5px;
    border-radius: 2px;
    font-style: normal;
    font-weight: bold;
  }
}
</style>
